import { PointOfSalesObject } from '@focus.cloud/src/interface/BluBookingInterfaces/PointOfSale';
import {
  ServiceInterface,
  ServicesObject,
} from '@focus.cloud/src/interface/BluBookingInterfaces/Service';
import { StudiObject } from '@focus.cloud/src/interface/BluBookingInterfaces/Studio';
import { UsersObject } from '@focus.cloud/src/interface/BluBookingInterfaces/User';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ServiceRootSliceState {
  pointOfSales: PointOfSalesObject;
  services: ServicesObject;
  studi: StudiObject;
  users: UsersObject;
  serviceLoad: boolean;
  openForm?: 'modify' | 'info' | 'new';
  currentService: string;
  deleteService?: string;
}

const initialState: ServiceRootSliceState = {
  pointOfSales: {},
  services: {},
  studi: {},
  users: {},
  serviceLoad: true,
  currentService: '',
};

const ServiceRootSlice = createSlice({
  name: 'ServiceRoot',
  initialState,
  reducers: {
    setOpenForm(
      state: ServiceRootSliceState,
      action: PayloadAction<'modify' | 'info' | 'new' | undefined>,
    ) {
      state.openForm = action.payload;
    },
    setCurrentService(
      state: ServiceRootSliceState,
      action: PayloadAction<string>,
    ) {
      state.currentService = action.payload;
    },

    setDeleteService(
      state: ServiceRootSliceState,
      action: PayloadAction<string | undefined>,
    ) {
      state.deleteService = action.payload;
    },
    setServiceData(
      state: ServiceRootSliceState,
      action: PayloadAction<{
        pointOfSales: PointOfSalesObject;
        services: ServicesObject;
        studi: StudiObject;
        users: UsersObject;
        serviceLoad: boolean;
      }>,
    ) {
      return {
        ...state,
        ...action.payload,
      };
    },
    setServices(
      state: ServiceRootSliceState,
      action: PayloadAction<{ [x: string]: ServiceInterface }>,
    ) {
      state.services = action.payload;
    },
    setServiceLoad(
      state: ServiceRootSliceState,
      action: PayloadAction<boolean>,
    ) {
      state.serviceLoad = action.payload;
    },
  },
});

export const {
  setOpenForm,
  setCurrentService,
  setDeleteService,
  setServiceData,
  setServiceLoad,
  setServices,
} = ServiceRootSlice.actions;

export default ServiceRootSlice.reducer;
